/*
 * @author: xd
 * @Date: 2021-12-18 10:21:19
 * @LastEditors: xd
 * @LastEditTime: 2021-12-18 11:22:07
 * @Description: 数据加密解密
 */

import * as DES from "crypto-js/tripledes";
import * as UTF8 from "crypto-js/enc-utf8";

export class Secret{
  constructor() {
    
  }
  /**
   * @description:加密
   * @param {*}
   * @return {*}
   */
  Encrypt1(word: string): string {
    return DES.encrypt(word, "apple3D").toString();
  }

  /**
   * @description: 解密
   * @param {string} word
   * @return {*}
   */  
  Decrypt1(word: string): string {
    return DES.decrypt(word, "apple3D").toString(UTF8);
  }
  //解密方法
  Decrypt(word: string) {
    let key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
    let iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  }

  //加密方法
  Encrypt(word: string) {
    let key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
    let iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString().toUpperCase();
  }
}
